/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function UpdateSiteContactRequestSiteContactFromJSON(json) {
    return UpdateSiteContactRequestSiteContactFromJSONTyped(json, false);
}
export function UpdateSiteContactRequestSiteContactFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        expiredOn: !exists(json, 'expired_on') ? undefined : json['expired_on'],
        canViewable: !exists(json, 'can_viewable') ? undefined : json['can_viewable']
    };
}
export function UpdateSiteContactRequestSiteContactToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        expired_on: value.expiredOn,
        can_viewable: value.canViewable
    };
}
